import { ScrollArea } from '@/components/_ui/ScrollArea'
import T from '@/components/Helpers/Translate'
import { useGTM } from '@/lib/hooks/google-analytics/useGTM'
import useParseLinkUrlWithLocale from '@/lib/hooks/routing/useParseLinkUrlWithLocale'
import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import { MixpanelEvent } from '@/lib/services/mixpanel/mixpanelEvent'
import useGlobalStore from '@/store/useGlobalStore'

export const MobileHeaderQuickLinks = () => {
  const { user } = useGlobalStore()
  const { gtm } = useGTM()
  const { parseLinkUrlWithLocale } = useParseLinkUrlWithLocale()

  const quickLink = (label: string, url: string) => (
    <a
      className="cursor-pointer text-center text-sm font-medium no-underline hover:underline"
      onClick={() => {
        gtm.navigationBarNavLinkClicked(label)

        mixpanelService
          .trackEvent(MixpanelEvent.NAVIGATION_BAR_NAV_LINK_CLICKED, {
            action: label,
          })
          .catch(() => {})
      }}
      href={url}
    >
      <T>{label}</T>
    </a>
  )

  if (
    !user.isSignedIn ||
    !['Associate', 'Member'].includes(user.customerType)
  ) {
    return null
  }

  return (
    <ScrollArea
      className="max-w-screen data-[orientation=horizontal] whitespace-nowrap"
      type="always"
      aria-orientation="horizontal"
    >
      <div
        className={`flex h-12 items-center bg-sky-100 px-5 ${
          user.customerType === 'Associate'
            ? 'justify-evenly'
            : 'justify-between'
        }`}
      >
        {/*  Buy again is not yet implemented, after implementation justify-between should be used instead of ternary operator */}
        <div className="flex w-max justify-around gap-4">
          {quickLink(
            'my_subscriptions',
            parseLinkUrlWithLocale({ url: '/account/subscriptions' }),
          )}
          {user.customerType === 'Member' &&
            quickLink(
              'order_status',
              parseLinkUrlWithLocale({ url: '/account/order-history' }),
            )}
          {quickLink(
            'referral_link',
            parseLinkUrlWithLocale({ url: '/account/invite' }),
          )}
        </div>
      </div>
    </ScrollArea>
  )
}
